export default "__VITE_ASSET__f94b497a__"